import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { loader, p } from "~/misc/common";
import QrScanner from "qr-scanner";
import { createConsumer } from "@rails/actioncable";

export default class extends Controller {
	async connect() {
		p('initQrContractApp');
		const el = this.element as HTMLDivElement;

		const video = document.getElementById("preview") as HTMLVideoElement;

		let mirrored = false;
		function refreshMirror() {
			mirrored ? $('#flip').addClass('active') : $('#flip').removeClass('active');
			video.style.transform = mirrored ? 'scaleX(-1)' : '';
		}
		$('#flip').on('click', function () {
			$('#flip').blur();
			mirrored = !mirrored;
			refreshMirror();
		});
		refreshMirror();

		const scanner = new QrScanner(
			video,
			onScan,
			{
				highlightScanRegion: true,
				highlightCodeOutline: true,
			}
		);

		const cameras = await QrScanner.listCameras(true);
		let currentCamera = cameras.findIndex(c =>
			c.label.toLowerCase().includes('back')
		);
		if (currentCamera < 0) currentCamera = 0;

		if (cameras.length > 0) {
			scanner.setCamera(cameras[currentCamera].id);
			scanner.start();
			if (cameras.length > 1) {
				$('#change').show(300);
			}
		} else {
			p('No cameras found.');
		}

		let last: string | null = null;
		let timeout: number | null = null;
		function onScan(result: QrScanner.ScanResult) {
			const content = result.data;
			if (last !== content) {
				last = content;
				onNewData(content);
			}
			if (timeout) clearTimeout(timeout);
			timeout = setTimeout(() => { last = null; }, 1000);
		}

		function onNewData(data: string) {
			p(data);
			var new_status = $('#contract_status_id').myGetNumValue();
			if (data.startsWith('GR')) {
				window.open('/group_reports/' + data.replace('GR', ''), '_blank');
			}
			if (data.startsWith('MR')) {
				window.open('/mission_reports/' + data.replace('MR', ''), '_blank');
			}
			if (data.startsWith('TRN')) {
				window.open('/trainings/' + data.replace('TRN', '') + '/attendance', '_blank');
			}
			if (data.startsWith('CT')) {
				const base_url = '/contracts/' + data.replace(/CTC|CTA|CTJ|CTI|CTS|CTM/, '');
				if (!new_status) {
					window.open(base_url, '_blank');
				} else {
					$.ajax({
						url: base_url + '.json',
						type: 'PUT',
						data: {
							contract: {
								status_id: new_status
							}
						},
					}).always(function (result) {
						window.open(base_url, '_blank');
					});
				}
			}
			($('#beep')[0] as HTMLAudioElement).play();
		}

		$('#change').on('click', async function () {
			$('#change').blur();
			if (cameras.length <= 1) return;

			try {
				currentCamera = (currentCamera + 1) % cameras.length;
				await scanner.setCamera(cameras[currentCamera].id);
				p('Switched camera to: ' + cameras[currentCamera].label);
				// Optional: auto-mirror front cameras
				const label = cameras[currentCamera].label.toLowerCase();
				mirrored = label.includes('front');
				refreshMirror();
			} catch (e) {
				console.error(e);
				alert('Failed to switch camera.');
			}
		});

		const user_id = el.dataset.userid!;
		const connection = createConsumer().subscriptions.create(
			{ channel: 'AndroidChannel', id: user_id },
			{
				connected() {
					p('connected');
					connection.send({
						action: 'qr',
						discovery_question: true
					});
					//this.perform('really_subscribed');
				},
				disconnected() {
					p('disconnected');
				},
				received: (data: any) => {
					p(data);
					switch (data.action) {
						case 'qr':
							if (data.msg.discovery_answer) {
								scanner.stop();
								$('.qr').hide();
								$('#remote').show();
							}
							if (data.msg.data) {
								onNewData(data.msg.data);
							}
							break;
					}
				},
			}
		);
	}
}